import React, { Component } from 'react';

import { StepWrapper } from '../styles';
import {
	ProgressWrapper,
	ProgressBarLabel,
	ProgressBarBackground,
	ProgressBarMarker,
	EtlProgressLabel,
} from './styles';

export default class UploadProgressBar extends Component {
	render() {
		const { label, value, etl } = this.props;

		return (
			<StepWrapper>
				<ProgressWrapper>
					{etl ? (
						<EtlProgressLabel>{label}</EtlProgressLabel>
					) : (
						<ProgressBarLabel>{label}</ProgressBarLabel>
					)}
					<ProgressBarBackground>
						<ProgressBarMarker style={{ width: `${value}%` }} />
					</ProgressBarBackground>
				</ProgressWrapper>
			</StepWrapper>
		);
	}
}
